import { MyAssetsList } from '../MyAssetsList/MyAssetsList';
import {
  TabsContent,
  TabsList,
  TabsRoot,
  TabsTrigger,
  TabsTriggerLink,
} from '../Tabs/Tabs';
import { MyAssetsTabsProps } from './types';

export const MyAssetsTabs = ({
  assetUrl,
  upmPackages,
  microcopy,
  className = '',
  ...actions
}: MyAssetsTabsProps) => {
  return (
    <TabsRoot defaultValue="upmPackages" className={className}>
      <TabsList>
        <TabsTriggerLink value="assets" url={assetUrl}>
          {microcopy.assets}
        </TabsTriggerLink>
        <TabsTrigger value="upmPackages">{microcopy.upmPackages}</TabsTrigger>
      </TabsList>
      <TabsContent value="upmPackages" className="lg:pt-9">
        <MyAssetsList
          {...upmPackages}
          {...actions}
          microcopy={microcopy.list}
        />
      </TabsContent>
    </TabsRoot>
  );
};
